import { render, staticRenderFns } from "./MenuListLink.vue?vue&type=template&id=44e01327&scoped=true&lang=pug"
import script from "./MenuListLink.vue?vue&type=script&lang=js"
export * from "./MenuListLink.vue?vue&type=script&lang=js"
import style0 from "./MenuListLink.vue?vue&type=style&index=0&id=44e01327&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e01327",
  null
  
)

export default component.exports